import { Component, ViewEncapsulation, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { NbAuthService, NbTokenService } from "@nebular/auth";
import { Router } from "@angular/router";
import { StorageService } from "../../../../shared/services/storage.service";
import { IpLocationService } from "../../../services/ip-location.service";
import { AmbienteBanco, AmbienteLoginService } from "../../../../shared/services/ambiente/ambiente-login.service";
import { PresencaEscritorioColetaService } from "../../../../pages/recursos-humanos/shared/services/presenca-escritorio-coleta.service";

@Component({
  selector: 'ngx-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'full-screen-login'
  }
})
export class NgxLoginComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('loginContainer', { static: true }) loginContainer: ElementRef;
  @ViewChild('form') loginForm: NgForm;

  private temporizadoresAutofill: number[] = [];
  
  showPassword = true;
  provider: string = '';
  strategy = 'email';
  user: any = {
      email: '',
      password: '',
      rememberMe: false
  };
  hide = true;
  isIpAllowed: boolean = true;
  isIpValidated: boolean = false;
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  showMessages = {
    error: false,
    success: false
  };
  rememberMe = false;
  socialLinks = [];
  currentCountry: string = '';
  permitirTrocaAmbiente = false;
  ambienteSelecionado: AmbienteBanco = 'Desenvolvimento';
  opcoesAmbiente: { valor: AmbienteBanco; rotulo: string }[] = [];

  constructor(
    private authService: NbAuthService,
    private tokenService: NbTokenService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private ipLocationService: IpLocationService,
    private storageService: StorageService,
    private ambienteLogin: AmbienteLoginService,
    private presencaColeta: PresencaEscritorioColetaService
  ) {}

  ngOnInit() {
    // Remove qualquer layout padrão do Nebular
    this.removeNebularLayout();
    
    // this.checkIpLocation();
    this.currentCountry = 'BR';
    this.isIpAllowed = true;
    this.isIpValidated = true;
    this.cd.detectChanges();
    
    this.loadSavedCredentials();
    this.permitirTrocaAmbiente = this.ambienteLogin.permitirTrocaAmbiente;
    this.opcoesAmbiente = this.ambienteLogin.opcoes;
    this.ambienteSelecionado = this.ambienteLogin.ambiente;
  }

  ngAfterViewInit() {
    // Garante que o componente ocupe toda a tela
    this.ensureFullScreen();
    // O navegador preenche e-mail/senha depois da tela montar e nem sempre avisa o formulário.
    [0, 200, 600, 1200, 2000].forEach((ms) => {
      const id = window.setTimeout(() => this.sincronizarCamposComTela(), ms);
      this.temporizadoresAutofill.push(id);
    });
  }

  ngOnDestroy() {
    this.temporizadoresAutofill.forEach((id) => window.clearTimeout(id));
  }

  removeNebularLayout() {
    // Remove classes e estilos padrão do Nebular
    const body = document.body;
    body.classList.add('custom-login-layout');
    
    // Remove qualquer container padrão do Nebular
    const nebularContainers = document.querySelectorAll('.nb-auth, .auth-block, .auth-container');
    nebularContainers.forEach(container => {
      if (container instanceof HTMLElement) {
        container.style.display = 'none';
      }
    });
  }

  ensureFullScreen() {
    if (!this.loginContainer) {
      return;
    }

    const container = this.loginContainer.nativeElement as HTMLElement;
    container.style.width = '100%';
    container.style.height = '100dvh';
    container.style.maxHeight = '100dvh';
    container.style.position = 'fixed';
    container.style.top = '0';
    container.style.left = '0';
    container.style.zIndex = '9999';
    container.style.overflowX = 'hidden';
    container.style.overflowY = 'auto';
  }

  loadSavedCredentials() {
    console.log('Carregando credenciais salvas...');
    
    const savedCredentials = this.storageService.getLocalItem('savedCredentials');
          
    if (savedCredentials) {
      try {
        const credentials = JSON.parse(savedCredentials);
    
        
        this.user.email = credentials.email || '';
        this.user.password = credentials.password || '';
        this.user.rememberMe = true;
        this.rememberMe = true;
 
      } catch (error) {
        console.error('Erro ao carregar credenciais salvas:', error);
        this.storageService.removeLocalItem('savedCredentials');
      }
    } else {
      console.log('Nenhuma credencial salva encontrada');
    }
  }

  checkIpLocation() {
    this.isIpValidated = false;
    this.ipLocationService.getIpLocation().subscribe({
      next: (result) => {
        console.log('Localização do IP:', {
          país: result.country,
          permitido: result.allowed,
          api: result.api
        });
        
        this.currentCountry = result.country;
        this.isIpAllowed = result.allowed;
        this.isIpValidated = true;
        this.cd.detectChanges();
      },
      error: (error) => {
        console.error('Erro ao verificar IP:', error);
        this.errors = ['Não foi possível verificar a localização do seu IP. Por favor, tente novamente mais tarde.'];
        this.showMessages.error = true;
        this.isIpValidated = true;
        this.cd.detectChanges();
      }
    });
  }

  getInputType() {
    return this.showPassword ? 'text' : 'password';
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  onFocus(event: FocusEvent): void {
    (event.target as HTMLElement).blur();
  }

  onPreenchimentoAutomatico(event: AnimationEvent): void {
    if (event.animationName === 'loginAutofillStart') {
      this.sincronizarCamposComTela();
    }
  }

  /**
   * Copia o valor visível dos campos para o formulário.
   * Autofill do navegador deixa o texto na tela sem atualizar o ngModel,
   * e o Entrar permanece desabilitado com "Preencha seu E-mail!".
   */
  sincronizarCamposComTela(): void {
    const email = this.lerCampo('input-email', this.user.email).trim();
    const senha = this.lerCampo('input-password', this.user.password);

    if (email && email !== this.user.email) {
      this.user.email = email;
      this.loginForm?.controls['e-mail']?.setValue(email);
    }

    if (senha && senha !== this.user.password) {
      this.user.password = senha;
      this.loginForm?.controls['password']?.setValue(senha);
    }
  }

  get podeEntrar(): boolean {
    return !this.submitted && this.isIpValidated && this.camposPreenchidos();
  }

  temEmailVisivel(): boolean {
    return this.lerCampo('input-email', this.user.email).trim().length > 0;
  }

  private camposPreenchidos(): boolean {
    const email = this.lerCampo('input-email', this.user.email).trim();
    const senha = this.lerCampo('input-password', this.user.password);
    return /.+@.+\..+/.test(email) && senha.length > 0;
  }

  private lerCampo(id: string, modelo: string): string {
    const el = document.getElementById(id) as HTMLInputElement | null;
    if (el) {
      return el.value || '';
    }
    return modelo || '';
  }

  togglePasswordVisibility(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.hide = !this.hide;
  }

  onAmbienteChange(ambiente: AmbienteBanco): void {
    this.ambienteSelecionado = ambiente;
    this.ambienteLogin.definir(ambiente);
  }

  login(): void {
    if (this.submitted) {
      return;
    }

    if (!this.isIpAllowed || !this.isIpValidated) {
      console.log('Tentativa de login bloqueada - IP não permitido ou não validado');
      return;
    }

    this.sincronizarCamposComTela();

    if (!this.camposPreenchidos()) {
      this.loginForm?.control.markAllAsTouched();
      this.cd.detectChanges();
      return;
    }

    this.submitted = true;
    this.errors = [];
    this.messages = [];
    this.showMessages.error = false;
    this.showMessages.success = false;

    if (this.permitirTrocaAmbiente) {
      this.ambienteLogin.definir(this.ambienteSelecionado);
    }

    this.authService.authenticate(this.strategy, this.user).subscribe({
      next: (result: any) => {
        this.submitted = false;
        if (result.isSuccess()) {
          // Traduz as mensagens de sucesso
          const originalMessages = result.getMessages();
          this.messages = originalMessages.map((message: string) => this.translateSuccessMessage(message));
          this.showMessages.success = true;
          
          // Salvar credenciais se "lembrar senha" estiver marcado
          if (this.user.rememberMe) {
            const credentialsToSave = {
              email: this.user.email,
              password: this.user.password
            };
            
            try {
              this.storageService.setLocalItem('savedCredentials', JSON.stringify(credentialsToSave));
            } catch (error) {
              console.error('Erro ao salvar credenciais:', error);
            }
          } else {
            this.storageService.removeLocalItem('savedCredentials');
          }

          this.presencaColeta.iniciar();
          this.router.navigate(['/pages']);
        } else {
          const rawErrors = result.getErrors();
          const originalErrors = Array.isArray(rawErrors)
            ? rawErrors
            : rawErrors != null && String(rawErrors).length
              ? [String(rawErrors)]
              : [];
          this.errors = originalErrors.map((error: string) => this.translateErrorMessage(error));
          this.showMessages.error = true;
        }
        this.cd.detectChanges();
      },
      error: (error) => {
        console.log('Erro no login:', error);
        this.submitted = false;
        this.errors = ['Ocorreu um erro ao tentar fazer login. Por favor, tente novamente.'];
        this.showMessages.error = true;
        this.cd.detectChanges();
      }
    });
  }

  /**
   * Traduz mensagens de erro do inglês para português
   */
  private translateErrorMessage(error: string): string {
    const errorTranslations: { [key: string]: string } = {
      // Resposta da API (BadRequest sign-in)
      'Usuário ou senha inválidos': 'E-mail ou senha incorretos.',
      'Login/Email combination is not correct, please try again.': 'Combinação de Login/E-mail incorreta, por favor tente novamente.',
      'Email is required!': 'E-mail é obrigatório!',
      'Email should be the real one!': 'O e-mail deve ser válido!',
      'Password is required!': 'Senha é obrigatória!',
      'Password should contain from': 'A senha deve conter de',
      'characters': 'caracteres',
      'Invalid credentials': 'Credenciais inválidas',
      'User not found': 'Usuário não encontrado',
      'Account is locked': 'Conta está bloqueada',
      'Account is disabled': 'Conta está desabilitada',
      'Too many failed attempts': 'Muitas tentativas falharam',
      'Session expired': 'Sessão expirada',
      'Network error': 'Erro de conexão',
      'Server error': 'Erro do servidor',
      'Authentication failed': 'Falha na autenticação'
    };

    // Procura por uma tradução exata
    if (errorTranslations[error]) {
      return errorTranslations[error];
    }

    // Procura por traduções parciais (para casos onde a mensagem pode variar)
    for (const [english, portuguese] of Object.entries(errorTranslations)) {
      if (error.toLowerCase().includes(english.toLowerCase())) {
        return portuguese;
      }
    }

    // Se não encontrar tradução, retorna a mensagem original
    return error;
  }

  /**
   * Traduz mensagens de sucesso do inglês para português
   */
  private translateSuccessMessage(message: string): string {
    const successTranslations: { [key: string]: string } = {
      'You have been successfully logged in.': 'Login realizado com sucesso',
      'Authentication successful': 'Autenticação bem-sucedida',
      'User logged in': 'Usuário logado com sucesso',
      'Password changed': 'Senha alterada com sucesso',
      'Account created': 'Conta criada com sucesso',
      'Email verified': 'E-mail verificado com sucesso',
      'Token refreshed': 'Token atualizado com sucesso',
      'Session restored': 'Sessão restaurada com sucesso',
      'Password reset': 'Senha resetada com sucesso',
      'User registered': 'Usuário registrado com sucesso',
      'User updated': 'Usuário atualizado com sucesso',
      'User deleted': 'Usuário excluído com sucesso',
      'User logged out': 'Usuário deslogado com sucesso',
      'User locked': 'Usuário bloqueado com sucesso',
      'User unlocked': 'Usuário desbloqueado com sucesso',
      'User disabled': 'Usuário desabilitado com sucesso',
      'User enabled': 'Usuário habilitado com sucesso',
      'User role changed': 'Função do usuário alterada com sucesso',
      'User profile updated': 'Perfil do usuário atualizado com sucesso',
      'User password updated': 'Senha do usuário atualizada com sucesso',
      'User email updated': 'E-mail do usuário atualizado com sucesso',
      'User phone updated': 'Telefone do usuário atualizado com sucesso',
      'User address updated': 'Endereço do usuário atualizado com sucesso',
      'User settings updated': 'Configurações do usuário atualizadas com sucesso',
      'User preferences updated': 'Preferências do usuário atualizadas com sucesso',
      'User notifications updated': 'Notificações do usuário atualizadas com sucesso',
      'User sessions updated': 'Sessões do usuário atualizadas com sucesso',
      'User roles updated': 'Funções do usuário atualizadas com sucesso',
      'User permissions updated': 'Permissões do usuário atualizadas com sucesso',
      'User groups updated': 'Grupos do usuário atualizados com sucesso',
      'User organizations updated': 'Organizações do usuário atualizadas com sucesso'
    };

    // Procura por uma tradução exata
    if (successTranslations[message]) {
      return successTranslations[message];
    }

    // Procura por traduções parciais (para casos onde a mensagem pode variar)
    for (const [english, portuguese] of Object.entries(successTranslations)) {
      if (message.toLowerCase().includes(english.toLowerCase())) {
        return portuguese;
      }
    }

    // Se não encontrar tradução, retorna a mensagem original
    return message;
  }

  getConfigValue(key: string): any {
    return true;
  }

  onForgotPasswordClick(): void {
    this.router.navigate(['/auth/request-password']);
  }
}
  
